import { useRoutes } from "react-router-dom";
import { Navigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
// routes
import MainRoutes from "./MainRoutes";
import AuthenticationRoutes from "./AuthenticationRoutes";
// import LoginRoutes from "./LoginRoutes";
import config from "../config";
import CustomRoutes from "./CustomRoutes";
import CustomerPortalRoutes from "../modules/customer-portal/routes/CustomerPortalRoutes";
import { getCustomerPortalSession } from "../modules/customer-portal/constants/auth";
// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
  const location = useLocation();
  const customerPortalSession = getCustomerPortalSession();
  const isCustomerPortalPath = location.pathname.startsWith("/customer-portal");
  const isCustomerRootApp = config.rootApp === "customer";
  const isBothRootApp = config.rootApp === "both";

  // Customer-only builds keep signed-in portal users inside portal routes.
  // Do not apply this on ROOT_APP=main — that app should never send people to /customer-portal/dashboard.
  if (isCustomerRootApp && customerPortalSession && !isCustomerPortalPath) {
    return <Navigate to="/customer-portal/dashboard" replace />;
  }

  // ROOT_APP=both -> allow both main and customer routes in one build (development mode).
  if (isBothRootApp) {
    return useRoutes([
      { path: config.basePath + "/", element: <Navigate to={config.defaultPath} /> },
      CustomerPortalRoutes,
      CustomRoutes,
      AuthenticationRoutes,
      MainRoutes,
    ]);
  }

  // ROOT_APP=customer -> only customer-portal routes are allowed.
  // Any non-customer route redirects to customer base route.
  if (isCustomerRootApp) {
    if (!isCustomerPortalPath) {
      return <Navigate to={config.defaultPath} replace />;
    }

    return useRoutes([
      { path: config.basePath + "/", element: <Navigate to={config.defaultPath} /> },
      CustomerPortalRoutes,
      { path: "*", element: <Navigate to={config.defaultPath} replace /> },
    ]);
  }

  // ROOT_APP=main (default, including when env is unset) -> salon app only.
  // Customer portal is a separate React app. Never render /customer-portal pages here.
  if (isCustomerPortalPath) {
    return <Navigate to={config.basename || "/login"} replace />;
  }

  // return useRoutes([{ path: "/", element: <Navigate to={config.defaultPath} /> }, AuthenticationRoutes, LoginRoutes, MainRoutes], config.basename);
  return useRoutes([
    { path: config.basePath + "/", element: <Navigate to={config.defaultPath} /> },
    CustomRoutes,
    AuthenticationRoutes,
    MainRoutes,
  ]);
  // return useRoutes([{ path: "/", element: <Navigate to={config.defaultPath} /> }, AuthenticationRoutes], config.basename);
}
